export default __webpack_public_path__ + "static/media/cornerLogo.43f2ecbd.svg";